import { render, staticRenderFns } from "./_cpType.vue?vue&type=template&id=a9755b1a&scoped=true&"
import script from "./_cpType.vue?vue&type=script&lang=js&"
export * from "./_cpType.vue?vue&type=script&lang=js&"
import style0 from "./_cpType.vue?vue&type=style&index=0&id=a9755b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9755b1a",
  null
  
)

export default component.exports